// @ts-check
import Axios from "axios";
import { Appsettings } from "../Appsettings";
/**
 *
 * @param {string} phone
 * @param {Object} message
 * @param {string} message.nombre
 * @param {string} message.link
 * @param {string} message.token
 */
export async function shareWhatsapp(phone, message) {
  if (phone === "") {
    alert("numero telefonico invalido");
    return;
  }
  let templateReq = await Axios.get(Appsettings.whatsappMessage, {
    headers: { "Cache-Control": "no-cache" },
  });
  let template = templateReq.data;
  const link = window.location.origin + "/externo/" + message.token;
  template = template.replace("[[NOMBRE]]", message.nombre);
  template = template.replace("[[LINK]]", link);
  const url = `https://wa.me/${phone}?text=${template}`;
  window.open(url, "_blank");
}

export default shareWhatsapp;
